import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoute from "./routes/AppRoute";
import SnackBar from "./components/custom-snackbar/SnackBar";
import { Provider } from "react-redux";
import store from "./redux-store/store";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <SnackBar />
          <AppRoute />
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
